module.exports = __webpack_public_path__ + "img/icon-generic-night.a9033c5d.svg";